<template>
    <input type="hidden" :name="name" :id="name" v-model="token">
</template>

<script>
    export default {
        props: {
            name: {
                type: String,
                default: 'g-recaptcha-response',
            },
            action: {
                required: true,
                type: String,
            },
        },
        data() {
            return {
                token: null,
            }
        },
        computed: {
            isReady() {
                return (this.token !== null);
            }
        },
        mounted() {
            this.getToken();
        },
        methods: {

            async setNewToken() {
                this.token = await this.$captcha(this.action);

                this.$emit('captcha-token-updated', this.token);

                return this.token;
            },

            getToken() {

                if (this.token === null) {
                    return this.setNewToken();
                }

                return this.token;
            },

        },
    }
</script>
